import * as React from 'react';
import classnames from 'classnames';
import { useConfiguratorContext } from '../../Context/ConfiguratorContext.js';
import { usePrivateSteppingContext } from '../../Context/PrivateSteppingContext.js';
import { ExpanderContainer } from './components/Expander/ExpanderContainer.js';
import { TopBar } from './components/TopBar/TopBar.js';

const ConfiguratorFooter = ()=>{
    const { isFooterOpen  } = useConfiguratorContext();
    const { footerTopBarContent , footerExpanderContent  } = usePrivateSteppingContext();
    return /*#__PURE__*/ React.createElement("footer", {
        "data-t": "configurator-footer",
        className: classnames('configurator-footer', {
            'configurator-footer--summary-expanded': isFooterOpen
        })
    }, /*#__PURE__*/ React.createElement(TopBar, null, footerTopBarContent), /*#__PURE__*/ React.createElement(ExpanderContainer, null, footerExpanderContent));
};

export { ConfiguratorFooter };
//# sourceMappingURL=ConfiguratorFooter.js.map
